function Judge() {
    //判断是否是对象
    this.isObject = (value) => {
        if (typeof value === 'object' && !Array.isArray(value)) {
            return true;
        }
    }
    //是否为JSON
    this.isJSON = (str) => {
        if (typeof str == 'string') {
            try {
                var obj = JSON.parse(str);
                if (typeof obj == 'object' && obj) {
                    return true;
                } else {
                    return false;
                }

            } catch (e) {
                return false;
            }
        }
    }
    //是否为数字
    this.isNumber = (val) => {
        return typeof val === 'number';
    }

    //Object转JSON
    this.objectToJson = (data) => {
        return JSON.stringify(data);
    }

    //对象深拷贝
    this.objectFullCopy = (object) => {
        return JSON.parse(JSON.stringify(object));
    }


    this.formatDateTime = (inputTime) => {
        var date = new Date(inputTime);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? ('0' + minute) : minute;
        second = second < 10 ? ('0' + second) : second;
        return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;

    }
}
export default new Judge();